<div class="filter-dialog">
    <div class="close-button">
        <span appIcon="close"
              class="close-icon"
              (click)="showResults()"
        ></span>
    </div>
    <div class="filters">
        <app-expansion-panel [allowMultiOpen]="true">
            <app-expansion-item title="{{ 'dealers.dealer-type' | translate }}"
                                [isExpanded]="true"
            >
                <ng-template expansionPanelContent>
                    <app-refinement-list-base attribute="types"
                                              operator="and"
                                              [localisedAttribute]="'dealers.dealer-type' | translate"
                                              [instantSearchInstance]="data.instantSearchInstance"
                                              [initialiseFromUrl]="false"
                    ></app-refinement-list-base>
                </ng-template>
            </app-expansion-item>

            <app-expansion-item title="{{'navigation.brands' | translate }}"
                                [isExpanded]="true"
            >
                <ng-template expansionPanelContent>
                    <app-refinement-list-base attribute="brands"
                                              operator="or"
                                              [instantSearchInstance]="data.instantSearchInstance"
                                              [initialiseFromUrl]="false"
                    ></app-refinement-list-base>
                </ng-template>
            </app-expansion-item>
        </app-expansion-panel>
    </div>

    <div class="button-row">
        <app-button theme="line"
                    (click)="clearFilters()"
        >
            {{ 'dealers.clear-all' | translate }}
        </app-button>

        <app-button theme="dark"
                    (click)="showResults()"
        >
            {{ 'dealers.show-x-results' | translate: { results: data.instantSearchInstance.instantSearchInstance.helper?.lastResults?.nbHits } }}
        </app-button>
    </div>
</div>
